import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})

export class SupPurorgService extends BaseService {
  constructor(http: HttpClient) { super(http); }
  private url = 'api/sup-purorg';
  getUrl(): string {
    return this.url;
  }


}
